import type { SupabaseClient } from '@supabase/supabase-js';

export type HistoryInsertCore = {
    contact_id: string;
    actor_id?: string | null;
    action: string;
    details?: Record<string, unknown>;
};

function isMissingHistoryTable(err: any) {
    const msg = String(err?.message || err?.details || err);
    return /relation .*contact_history.* does not exist/i.test(msg) || /table .*contact_history.* does not exist/i.test(msg);
}

export async function addHistoryCore(supabase: SupabaseClient, entry: HistoryInsertCore) {
    const { data, error } = await supabase
        .from('contact_history')
        .insert({
            contact_id: entry.contact_id,
            actor_id: entry.actor_id ?? null,
            action: entry.action,
            details: entry.details ?? {},
        })
        .select('*')
        .single();
    if (error) {
        if (isMissingHistoryTable(error)) {
            throw new Error('History feature not initialized. Apply migration 20250812_create_contact_history.sql');
        }
        throw error;
    }
    return data;
}

export async function listHistoryCore(supabase: SupabaseClient, contactId: string, limit = 50) {
    const { data, error } = await supabase
        .from('contact_history')
        .select('*')
        .eq('contact_id', contactId)
        .order('at', { ascending: false })
        .limit(limit);
    if (error) {
        if (isMissingHistoryTable(error)) {
            throw new Error('History feature not initialized. Apply migration 20250812_create_contact_history.sql');
        }
        throw error;
    }
    return data ?? [];
}
